module.exports = __webpack_public_path__ + "img/emailresultz-logo.25643215.png";